import { I18n } from '../../../utils/i18n';
import { NAMESPACE } from '../constants';
const i18nConfig = require('../locales/de.json');

/**
 * get text from basket-locale through I18
 */
export const getRaLocale = (key: string): string => I18n.getInstance(NAMESPACE, i18nConfig).getValue(NAMESPACE, key);
